export default __webpack_public_path__ + "static/media/checked.35cf819f.svg";